import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private nav: NavController,
    private router: Router
  ) { }

  async canActivateFn(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      const auth = getAuth();
      onAuthStateChanged(auth, async (user) => {
        console.log('🔒 AuthGuard executing...');
        console.log('user', user);
        console.log('target URL:', state.url);

        if (user) {
          const customAttributes = (user as any)['reloadUserInfo'].customAttributes;
          const roles = JSON.parse(customAttributes).roles;
          console.log('roles', roles);

          // Allow access to sip-login for operators
          // if (state.url === '/sip-login' && roles.includes('operator')) {
          //   console.log('✅ Allowing access to sip-login for operator');
          //   resolve(true);
          //   return;
          // }

          // Redirect operators from main pages to sip-login
          if (roles.includes('operator') && (state.url === '/' || state.url === '')) {
            console.log('↩️ Redirecting operator to sip-login from:', state.url);
            await this.nav.navigateRoot('tabs/sip');
            resolve(false);
            return;
          }

          console.log('✅ Allowing normal access');
          resolve(true);
        } else {
          console.log('❌ No user, redirecting to login');
          this.nav.navigateRoot('login');
          resolve(false);
        }
      });
    });
  }
}
